export enum IconType {
    Material = 1,
    FontAwesome = 2,
    CustomFile = 3
}
